import React from 'react';
import { InputNumberProps } from 'antd';
import Input from 'components/components/Input';
import { ServicesType } from 'types/services';

export const getUnitQuantityText = (data: ServicesType): string => {
  const { priceType } = data;
  const quantityText = 'Number of';
  switch (priceType) {
    case 'per-day':
      return `${quantityText} days`;
    case 'per-hour':
      return `${quantityText} hours`;
    case 'per-week':
      return `${quantityText} weeks`;
    case 'per-month':
      return `${quantityText} months`;
    case 'per-year':
      return `${quantityText} years`;
    default:
      return 'Quantity';
  }
}

type Props = Pick<InputNumberProps<number>, 'value' | 'onChange' | 'precision'> & {
  label: string,
  name?: string,
};

const QuantityField = ({
  label, name, value, onChange, precision,
}: Props) => (
  <Input
    name={name}
    label={label}
    className="overview-column"
    required
    layout="vertical"
    rules={[{ required: true, type: precision === 0 ? 'integer' : 'number', min: 1 }]}
  >
    <Input.InputNumber min={1} precision={precision} value={value} onChange={onChange} placeholder="Enter quantity" className="quantity-select" />
  </Input>
);

QuantityField.defaultProps = { name: undefined };

export default QuantityField;
